import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Countries } from '../../schemas/rql';

export function withCountriesApollo<E>(Component) {
  return graphql<E, Countries.Query, Countries.Variables>(
    gql`
    query Countries {
      countries {
        countries {
          name
          countryCode
          subregions {
            name
            code
          }
        }
      }
    }
  `,
  )(Component);
}

export default withCountriesApollo;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/addresses/with_countries_apollo.ts